import { render, staticRenderFns } from "./SkinList.vue?vue&type=template&id=435f3dfb&"
import script from "./SkinList.vue?vue&type=script&lang=ts&"
export * from "./SkinList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports